module.exports = __webpack_public_path__ + "img/project_icno1.799946e7.png";